import { render } from "./AcceptOPD.vue?vue&type=template&id=494d43b3&scoped=true"
import script from "./AcceptOPD.vue?vue&type=script&lang=js"
export * from "./AcceptOPD.vue?vue&type=script&lang=js"

import "./AcceptOPD.vue?vue&type=style&index=0&id=494d43b3&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../../../DEV/_vue3/reactive-clinic/rc-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494d43b3"]])

export default __exports__